import { guid, minutesToTimeString, timeStringToMinutes } from "traveldesk-ui"

export default class ItineraryStopModel {
    public static Create(obj: ItineraryStopModel) {
        return Object.assign(new ItineraryStopModel(obj.index, obj.itineraryId), obj, {
            guid: obj.guid || guid()
        })
    }
    constructor(index: number, itineraryId: number) {
        this.index = index
        this.itineraryId = itineraryId
        this.guid = guid()
    }
    index: number = 0
    guid: string = ''
    itineraryId: number = 0
    time: number = 0
    timeEnd: number = 0
    get timeDescription() {
        return minutesToTimeString(this.time)
    }
    set timeDescription(value: string) {
        this.time = timeStringToMinutes(value)
    }
    get timeEndDescription() {
        return minutesToTimeString(this.timeEnd)
    }
    set timeEndDescription(value: string) {
        this.timeEnd = timeStringToMinutes(value)
    }
    name: string = ''
    description: string = ""
    address: string = ''
    lat: number = 0
    lng: number = 0
}